import React from 'react';
import { Link } from 'react-router-dom';
import { CompanyProfileSection } from 'features/account/enums';

type Props = {
  ifOnlyBillingInfoUnfilled?: boolean;
};

export default function AssignmentValidationError(props: Props) {
  const { ifOnlyBillingInfoUnfilled } = props;
  const link = ifOnlyBillingInfoUnfilled
    ? `/company-profile?section=${CompanyProfileSection.AdditionalInfo}`
    : `/company-profile?section=${CompanyProfileSection.PrimaryInfo}`;

  return (
    <div>
      {`Please enter all required `}
      <Link to={link}>profile</Link>
      {` data in order to create new assignment.`}
    </div>
  );
}
